var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g4, _path8, _g5, _path9, _path10, _g6, _path11, _path12, _path13, _path14, _g7, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _line, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _rect, _path43, _rect2, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3C486B(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 683.993,
    height: 596,
    viewBox: "0 0 683.993 596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_3c486b",
    "data-name": "3c486b",
    transform: "translate(-216.004 -117)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(2700 -3576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-11",
    transform: "translate(-2483.996 3693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2805",
    "data-name": "Path 2805",
    d: "M481.709,294.136C354.246,258.71,307.656-16.609,120.576,132.5-12.178,238.264,70.945,498.481,237.965,469.085c101.144-17.757,85.514-19.726,171.574,30.151,87.22,50.563,183.089,76.214,275.5-12.043,47.82-45.711,66.07-157.526,19.04-215.7C645.3,198.759,559.575,315.761,481.709,294.136Z",
    transform: "translate(-54.839 -88.559)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2806",
    "data-name": "Path 2806",
    d: "M481.709,294.136C354.246,258.71,307.656-16.609,120.576,132.5-12.178,238.264,70.945,498.481,237.965,469.085c101.144-17.757,85.514-19.726,171.574,30.151,87.22,50.563,183.089,76.214,275.5-12.043,47.82-45.711,66.07-157.526,19.04-215.7C645.3,198.759,559.575,315.761,481.709,294.136Z",
    transform: "translate(-54.839 -88.559)",
    fill: "#efefef",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-11",
    transform: "translate(-2481.762 4249.196)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-11",
    cx: 340.879,
    cy: 19.902,
    rx: 340.879,
    ry: 19.902,
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_3c486b-2",
    "data-name": "3c486b",
    transform: "translate(-8715.378 -1158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Consent-rafiki_6_",
    "data-name": "Consent-rafiki (6)",
    transform: "translate(8875.16 1173.441)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-3",
    transform: "translate(123.025 179.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M149.446,618.354H448.811a8.1,8.1,0,0,0,8.207-9.117l-45.5-451.769a10.325,10.325,0,0,0-10.045-9.117h-299.4a8.1,8.1,0,0,0-8.207,9.117l45.5,451.769a10.325,10.325,0,0,0,10.08,9.117Z",
    transform: "translate(-93.803 -134.35)",
    fill: "#3c486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M151.239,618.354H450.6a8.1,8.1,0,0,0,8.207-9.117l-45.5-451.769a10.325,10.325,0,0,0-10.045-9.117h-299.4a8.1,8.1,0,0,0-8.19,9.117l45.5,451.769a10.325,10.325,0,0,0,10.062,9.117Z",
    transform: "translate(-92.446 -134.35)",
    fill: "#3c486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M151.239,618.354H450.6a8.1,8.1,0,0,0,8.207-9.117l-45.5-451.769a10.325,10.325,0,0,0-10.045-9.117h-299.4a8.1,8.1,0,0,0-8.19,9.117l45.5,451.769a10.325,10.325,0,0,0,10.062,9.117Z",
    transform: "translate(-92.446 -134.35)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M164.481,183.254h98a6.492,6.492,0,0,0,6.58-7.315l-2.747-27.177a1.47,1.47,0,0,0-1.435-1.312H154.8a1.172,1.172,0,0,0-1.19,1.312l2.747,27.177A8.277,8.277,0,0,0,164.481,183.254Z",
    transform: "translate(-48.955 -135.024)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M181.311,147.683l1.155,11.392h14.665l-1.155-11.392a8.3,8.3,0,0,0-8.067-7.332,6.527,6.527,0,0,0-6.6,7.332Zm4.445.63a2.625,2.625,0,0,1,2.66-2.975,3.36,3.36,0,0,1,3.255,2.975,2.625,2.625,0,0,1-2.66,2.957,3.342,3.342,0,0,1-3.255-2.957Z",
    transform: "translate(-28.214 -140.349)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M164.481,183.254h98a6.492,6.492,0,0,0,6.58-7.315l-2.747-27.177a1.47,1.47,0,0,0-1.435-1.312H154.8a1.172,1.172,0,0,0-1.19,1.312l2.747,27.177A8.277,8.277,0,0,0,164.481,183.254Z",
    transform: "translate(-48.955 -135.024)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M400.725,156.76H103.67l43.014,441.951H443.739Z",
    transform: "translate(-86.404 -128.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M141.23,179.52H143.7l1.295,13.23h-2.415Z",
    transform: "translate(-58.236 -110.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M155.107,185.682l.56,5.775H153.3l-.542-5.477c-.175-1.75-1.137-2.66-2.66-2.66s-2.712,1.015-2.52,3.045l.49,5.092H145.71l-.98-10.08h2.222l.122,1.295a3.99,3.99,0,0,1,3.342-1.417,4.427,4.427,0,0,1,4.69,4.427Z",
    transform: "translate(-55.611 -109.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M155.34,182.528v.613h2.782l.175,1.89h-2.712l.8,8.12h-2.38l-.787-8.12h-1.75l-.192-1.89h1.75v-.647a2.922,2.922,0,0,1,3.272-3.5,4.042,4.042,0,0,1,2.2.542l-.49,1.75a2.537,2.537,0,0,0-1.347-.4C155.69,180.935,155.235,181.478,155.34,182.528Z",
    transform: "translate(-50.698 -111.391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M155.87,186.419a4.532,4.532,0,0,1,4.865-5.162,5.687,5.687,0,0,1,5.9,5.162,4.55,4.55,0,0,1-4.882,5.25A5.722,5.722,0,0,1,155.87,186.419Zm8.382,0a3.307,3.307,0,0,0-3.307-3.15,2.625,2.625,0,0,0-2.695,3.15,3.307,3.307,0,0,0,3.307,3.15,2.625,2.625,0,0,0,2.695-3.15Z",
    transform: "translate(-47.291 -109.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M168.865,181.263l.21,2.257a3.5,3.5,0,0,0-.56,0c-1.75,0-2.817,1.067-2.625,3.132l.472,4.882H164l-.98-10.08h2.257l.14,1.47A3.5,3.5,0,0,1,168.865,181.263Z",
    transform: "translate(-41.894 -109.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M184.835,185.682l.56,5.775h-2.362l-.542-5.477c-.175-1.75-1.085-2.66-2.52-2.66s-2.537,1.015-2.345,3.027l.507,5.11h-2.38l-.525-5.477c-.175-1.75-1.1-2.66-2.537-2.66s-2.52,1.015-2.327,3.027l.49,5.11H168.49l-.98-10.08h2.257l.123,1.277a3.762,3.762,0,0,1,3.167-1.4,4.217,4.217,0,0,1,3.5,1.75,4.27,4.27,0,0,1,3.622-1.75,4.357,4.357,0,0,1,4.655,4.427Z",
    transform: "translate(-38.527 -109.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M189.15,187.2h-7.927a3.5,3.5,0,0,0,3.5,2.415,3.255,3.255,0,0,0,2.625-1.085l1.417,1.452a4.62,4.62,0,0,1-3.9,1.645,5.74,5.74,0,0,1-6.09-5.25,4.48,4.48,0,0,1,4.725-5.162,5.547,5.547,0,0,1,5.617,5.25A5.167,5.167,0,0,1,189.15,187.2Zm-8.1-1.557h5.74a3.1,3.1,0,0,0-3.1-2.467,2.485,2.485,0,0,0-2.642,2.467Z",
    transform: "translate(-30.12 -109.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M195.38,179.138l1.365,14H194.47l-.123-1.295a3.8,3.8,0,0,1-3.22,1.435,5.547,5.547,0,0,1-5.617-5.25,4.392,4.392,0,0,1,4.62-5.162,4.532,4.532,0,0,1,3.377,1.365l-.49-5.25Zm-1.452,8.977a3.307,3.307,0,0,0-3.325-3.15,2.625,2.625,0,0,0-2.695,3.15,3.308,3.308,0,0,0,3.307,3.15,2.642,2.642,0,0,0,2.712-3.15Z",
    transform: "translate(-25.08 -111.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M195.9,186.218a6.02,6.02,0,0,1,6.44-6.79,7.437,7.437,0,0,1,5.46,2.2l-1.452,1.487a5.25,5.25,0,0,0-3.692-1.54,4.042,4.042,0,0,0-4.288,4.637,5.092,5.092,0,0,0,5.25,4.655A4.112,4.112,0,0,0,207,189.3l1.75,1.522a6.107,6.107,0,0,1-5.057,2.2,7.577,7.577,0,0,1-7.787-6.807Z",
    transform: "translate(-17.273 -111.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M203.57,186.419a4.532,4.532,0,0,1,4.865-5.162,5.7,5.7,0,0,1,5.9,5.162,4.55,4.55,0,0,1-4.882,5.25,5.722,5.722,0,0,1-5.88-5.25Zm8.382,0a3.307,3.307,0,0,0-3.325-3.15,2.625,2.625,0,0,0-2.677,3.15,3.29,3.29,0,0,0,3.29,3.15,2.625,2.625,0,0,0,2.712-3.15Z",
    transform: "translate(-11.518 -109.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M221.1,185.682l.56,5.775h-2.362l-.542-5.477c-.175-1.75-1.137-2.66-2.66-2.66s-2.712,1.015-2.52,3.045l.49,5.092H211.7l-.98-10.08h2.24l.122,1.295a3.99,3.99,0,0,1,3.342-1.417,4.427,4.427,0,0,1,4.672,4.427Z",
    transform: "translate(-6.121 -109.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M218.127,190.44l.735-1.75a7.454,7.454,0,0,0,3.622,1c1.5,0,2.082-.42,2.012-1.12-.193-1.925-6.265-.1-6.65-4.13-.192-1.925,1.418-3.167,4.147-3.167a8.75,8.75,0,0,1,3.867.875l-.735,1.75a6,6,0,0,0-2.975-.753c-1.435,0-2.065.473-2.012,1.137.21,2.047,6.282.228,6.667,4.182.175,1.89-1.452,3.115-4.287,3.115A8.645,8.645,0,0,1,218.127,190.44Z",
    transform: "translate(-0.788 -109.661)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M233.9,187.2h-7.927a3.5,3.5,0,0,0,3.5,2.415,3.29,3.29,0,0,0,2.642-1.085l1.417,1.452a4.637,4.637,0,0,1-3.92,1.645,5.775,5.775,0,0,1-6.09-5.25,4.5,4.5,0,0,1,4.725-5.162,5.53,5.53,0,0,1,5.617,5.25C233.882,186.691,233.9,186.971,233.9,187.2Zm-8.1-1.557h5.74a3.1,3.1,0,0,0-3.1-2.467,2.485,2.485,0,0,0-2.642,2.467Z",
    transform: "translate(3.442 -109.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M240.8,185.645l.56,5.775H239l-.577-5.39c-.175-1.75-1.155-2.66-2.66-2.66a2.472,2.472,0,0,0-2.52,3.045l.49,5.092h-2.31l-.98-10.08h2.24l.14,1.295a3.955,3.955,0,0,1,3.342-1.417,4.427,4.427,0,0,1,4.637,4.34Z",
    transform: "translate(8.668 -109.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M245.417,191.817a3.85,3.85,0,0,1-6.02-2.73l-.472-4.847h-1.662l-.193-1.89h1.75l-.228-2.31h2.38l.228,2.31h2.695l.193,1.89h-2.712l.472,4.795a1.47,1.47,0,0,0,1.54,1.522,2.012,2.012,0,0,0,1.295-.42Z",
    transform: "translate(13.64 -110.583)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    x2: 285.995,
    transform: "translate(30.723 110.178)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M369.011,226.915H125.925L124.63,213.72h243.1Z",
    transform: "translate(-70.685 -85.325)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(78.076 157.191)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M360.438,235.276H141.186a2.555,2.555,0,1,1,0-5.092H360.438a2.555,2.555,0,1,1,0,5.092Z",
    transform: "translate(-138.419 -230.175)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(55.678 169.904)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M371.279,242.55h-243.1a2.555,2.555,0,1,1,0-5.11h243.1a2.555,2.555,0,1,1,0,5.11Z",
    transform: "translate(-125.62 -237.44)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(56.92 182.609)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M371.971,249.81H128.885a2.555,2.555,0,1,1,0-5.11H371.971a2.555,2.555,0,0,1,0,5.11Z",
    transform: "translate(-126.33 -244.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(58.163 195.314)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M372.681,257.07H129.595a2.555,2.555,0,1,1,0-5.11H372.681a2.555,2.555,0,0,1,0,5.11Z",
    transform: "translate(-127.04 -251.96)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(59.599 208.036)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M373.308,264.322H130.2a2.555,2.555,0,0,1,0-5.092h243.1a2.555,2.555,0,0,1,0,5.092Z",
    transform: "translate(-127.861 -259.23)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(60.419 220.732)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M374.182,271.586H131.1a2.555,2.555,0,1,1,0-5.092H374.182a2.555,2.555,0,1,1,0,5.092Z",
    transform: "translate(-128.329 -266.485)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(61.661 233.436)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M351.092,278.846H131.805a2.555,2.555,0,1,1,0-5.092H351.092a2.555,2.555,0,1,1,0,5.092Z",
    transform: "translate(-129.039 -273.745)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M376.554,304.535H133.467L132.19,291.34H375.276Z",
    transform: "translate(-65.015 -27.113)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(91.253 293.04)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M368,312.906H148.715a2.555,2.555,0,1,1,0-5.092H368a2.555,2.555,0,1,1,0,5.092Z",
    transform: "translate(-145.949 -307.805)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(68.696 305.78)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M378.912,320.186H135.825a2.555,2.555,0,1,1,0-5.092H378.912a2.555,2.555,0,1,1,0,5.092Z",
    transform: "translate(-133.059 -315.085)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(70.344 318.458)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M379.448,327.422h-243.1a2.555,2.555,0,0,1,0-5.092h243.1a2.555,2.555,0,0,1,0,5.092Z",
    transform: "translate(-134.001 -322.33)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(71.586 331.154)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M380.211,334.686H137.054a2.555,2.555,0,0,1,0-5.092H380.211a2.555,2.555,0,1,1,0,5.092Z",
    transform: "translate(-134.711 -329.585)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(72.458 343.859)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M255.223,341.946H137.975a2.555,2.555,0,1,1,0-5.092H255.223a2.555,2.555,0,1,1,0,5.092Z",
    transform: "translate(-135.209 -336.845)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(152.748 422.423)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 89.703,
    height: 1.697
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M183.5,365.615a8.419,8.419,0,0,0-1.435-1.3,1.908,1.908,0,0,0,.14.263c.578,1.155,1.085,2.327,1.54,3.5a3.378,3.378,0,0,0,.28-1.645,2.135,2.135,0,0,0-.525-.823Z",
    transform: "translate(-27.615 27.619)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M198.414,385.049a.978.978,0,0,0,0-.14l-.3-.315a.229.229,0,0,0-.105-.193.246.246,0,0,1,0-.1q0-.315,0-.63c.263-2.047.315-4.147.455-6.23l6.4-2.66a32.709,32.709,0,0,0-2.362-6.37,33.867,33.867,0,0,0-3.692-5.827l-29.749,12.372h0a2.223,2.223,0,0,1-.613,1.54c-.455.332-1.347,0-1.382-.49l-.542.508a2.553,2.553,0,0,1-.63.595l.63-.595a3.908,3.908,0,0,0,.42-.7l-20.019,8.312a31.374,31.374,0,0,0,2.362,6.387,33.719,33.719,0,0,0,3.692,5.81l6.842-2.835a.7.7,0,0,1-.157-.4c-.175-2.24,6-3.972,7.595-4.6a2.468,2.468,0,0,1,2.5,0c-.35.508-1.033.648-1.592.945a6.458,6.458,0,0,0-1.365,1.137l28.524-11.847a15.312,15.312,0,0,0,.385,3.36c.14.682.262,1.47.49,2.2a15.278,15.278,0,0,1-.368,1.75.245.245,0,0,0,0,.122l-12.04,4.987h0a.525.525,0,0,1,.158.665,1.435,1.435,0,0,1-.56.455c-1.242.647-5.442,3.5-6.772,2.467a14.244,14.244,0,0,1,1.172-1.12l-19.565,8.207c8.89,7.227,21,9.73,31.377,5.407a21.345,21.345,0,0,0,2.117-1,1.835,1.835,0,0,1,.088-.682v-1.173a4.305,4.305,0,0,1,1.75-.945c-.14.647-.228,1.312-.35,1.977A26.547,26.547,0,0,0,205.8,382.074Z",
    transform: "translate(-53.961 26.314)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M148.257,406.646c0-.49-.122-1.05-.192-1.75a5.651,5.651,0,0,1,.088-1.54c-.14-.245-.28-.455-.4-.7a38.026,38.026,0,0,1-4.025-18.864l-.245.122a.577.577,0,0,1-.665,0,.735.735,0,0,1-.158-.333,8.942,8.942,0,0,1,.175-4.41l.193-.56a1.751,1.751,0,0,1,.752-.525.805.805,0,0,1,.665.087,32.951,32.951,0,0,1,5.582-12.53c.577-2.45,1.54-4.795,3.237-5.057a5.058,5.058,0,0,0-.245,1.61,31.779,31.779,0,0,1,10.5-7.1c16.135-6.7,35.629,0,46.234,14.875a1.746,1.746,0,0,1,.525,0c2.012.192,4.095,4.76,5.022,6.247.735,1.207,1.5,2.747.805,3.85a.84.84,0,0,1-.77.455.911.911,0,0,1-.228-.105,35.174,35.174,0,0,1-2.835,29.907,10.376,10.376,0,0,1,.228,4.83c8.452-10.8,10.185-26.424,3.1-40.652-10.027-20.177-33.967-30.029-53.374-21.962s-27.037,31.009-17.01,51.186a44.882,44.882,0,0,0,2.992,5.11,7.14,7.14,0,0,0,0-1.61Z",
    transform: "translate(-58.561 16.669)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M168.6,400.452c0,.508-.56.91-1.12,1a4.288,4.288,0,0,1-3.5-1.207l-.962-.892a20.033,20.033,0,0,1,2.712,0,42,42,0,0,1-20.457-18.62,10.921,10.921,0,0,0-.175,2.73v.577a19.251,19.251,0,0,0,.35,2.2c11.357,16.24,32.5,23.5,49.979,16.257a34.229,34.229,0,0,0,12.775-9.187v-1.4a32.721,32.721,0,0,1,.14-3.64,31.762,31.762,0,0,1-14.227,11.637,36.347,36.347,0,0,1-25.514.543Z",
    transform: "translate(-55.35 39.926)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M152.5,379.726l1.015-1.75a1.75,1.75,0,0,1,1.75-.525,7.961,7.961,0,0,0,1.925.175,2.557,2.557,0,0,1,.963-.105v.087l16.8-7a.438.438,0,0,1,0,.158v.14h0a3.1,3.1,0,0,1,.14.7.963.963,0,0,0,1.242.7,5.11,5.11,0,0,0,2.257-2.327l.367-.647a3.292,3.292,0,0,0,.368-.63l14.56-6.055a34.818,34.818,0,0,0-6.632-4.217,1.558,1.558,0,0,0-.21-.683,1.749,1.749,0,0,0-.4-.49c-.1.683-.21,1.347-.367,2.03l-.875.175a1.75,1.75,0,0,1-.577-1.645,2.468,2.468,0,0,1,.28-.857,1.539,1.539,0,0,0-.508.315,29.644,29.644,0,0,0-22.084,0,26.424,26.424,0,0,0-16.187,25.147l7.3-3.027A1.12,1.12,0,0,0,152.5,379.726Z",
    transform: "translate(-54.423 20.735)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M223.2,401.889a15.229,15.229,0,0,1,.228-1.522,19.863,19.863,0,0,1,0-2.048,2.905,2.905,0,0,1,1.4-2.047,44.571,44.571,0,0,0-4.742-21.577,49.086,49.086,0,0,0-27.474-24.307,6.783,6.783,0,0,0-.385.8c-.3.892-1.75.49-1.662-.455a3.045,3.045,0,0,0-.175-1.067,42.261,42.261,0,0,0-28.3,1.172,38.3,38.3,0,0,0-5.075,2.572c0,.718.123,1.417.192,2.135a3.343,3.343,0,0,1-1.75-1.137c-16.047,10.8-21.472,32.6-11.812,52.026a48.774,48.774,0,0,0,4.987,7.962,6.51,6.51,0,0,1,.525-2.4,8.63,8.63,0,0,0,.507-1.75,44.865,44.865,0,0,1-2.992-5.11c-10.027-20.177-2.4-43.136,17.01-51.186s43.346,1.75,53.374,21.962c7.087,14.227,5.355,29.854-3.1,40.652a8.319,8.319,0,0,0,0,1.05v4.34a38.08,38.08,0,0,0,10.062-18.742h-.192A1.75,1.75,0,0,1,223.2,401.889Z",
    transform: "translate(-60.021 15.214)",
    fill: "#3c486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M195.269,400.1c-17.5,7.245-38.622,0-49.979-16.257.193.962.42,1.942.647,2.887a4.708,4.708,0,0,1-.3,2.835,49,49,0,0,0,21.279,14.315,2.871,2.871,0,0,1,1.295-.858,5.254,5.254,0,0,1,2.03,0,.98.98,0,0,1,.543.158,1.259,1.259,0,0,1,.385.507c.262.56.543,1.1.822,1.75a41.65,41.65,0,0,0,24.832-2.047,37.414,37.414,0,0,0,11.357-7.332c-.1-1.75-.157-3.342-.14-5a34.231,34.231,0,0,1-12.775,9.047Z",
    transform: "translate(-55.191 42.258)",
    fill: "#3c486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M213.911,379.147a1.3,1.3,0,0,1-.472-1.33h0a36.591,36.591,0,0,0-1.54-3.5,1.911,1.911,0,0,1-.14-.262h-.105a3.972,3.972,0,0,1-1.417-1.26,8.083,8.083,0,0,0-.682-1.592c-.28-.385-.962-.175-1.225-.56-.578-.84-.507-1.61.21-1.75-10.6-14.91-30.1-21.577-46.234-14.875a31.778,31.778,0,0,0-10.5,7.1,7.839,7.839,0,0,1-.087,1.277,5.25,5.25,0,0,1-1.312,2.152,11.934,11.934,0,0,0-2.467,4.987c.193-1.085.42-3.062.875-4.97a32.952,32.952,0,0,0-5.582,12.53.6.6,0,0,1,.21.21,1.277,1.277,0,0,1,0,.77,4.515,4.515,0,0,0,.227,1.977,3.028,3.028,0,0,1,.262.857,2.031,2.031,0,0,1-1.452,1.75,38.027,38.027,0,0,0,4.025,18.865c.123.245.262.455.4.7l.1-.735c.14-.718.28-1.435.4-2.153a4.025,4.025,0,0,1-.157,3.08v.332a42,42,0,0,0,20.457,18.62,6.4,6.4,0,0,1,1.627.14c.542.14,1.085.21,1.277.683v.28a36.347,36.347,0,0,0,25.532-.542A31.762,31.762,0,0,0,210.376,410.3a7.368,7.368,0,0,1,.262-1.61,1.12,1.12,0,0,1,.472.472,35.174,35.174,0,0,0,2.8-30.012ZM165.454,360.16a29.644,29.644,0,0,1,22.084,0,1.539,1.539,0,0,1,.507-.315c.1-.245.245-.473.367-.7.315-.543.752-1.137,1.4-1.05a13.579,13.579,0,0,1-.227,2.047,1.751,1.751,0,0,1,.4.49,1.557,1.557,0,0,1,.21.682,34.822,34.822,0,0,1,6.632,4.217l-14.56,6.16a3.292,3.292,0,0,1-.368.63l-.368.648a5.11,5.11,0,0,1-2.257,2.327.963.963,0,0,1-1.243-.7,3.094,3.094,0,0,0-.14-.7h0v-.14a.437.437,0,0,0,0-.157l-16.8,7c-.787,1.085-1.75,2.222-3.22,2.065a7.8,7.8,0,0,1-1.172-.245l-7.3,3.027A26.424,26.424,0,0,1,165.454,360.16Zm31.114,53.531a10.257,10.257,0,0,1-.245,1.435,6.493,6.493,0,0,1-1.645,4.34,38.841,38.841,0,0,1,.42-4.952,21.353,21.353,0,0,1-2.117,1c-10.395,4.322-22.487,1.75-31.377-5.407l19.512-8.1,1.837-1.575a4.779,4.779,0,0,1,1.313-.875,5.147,5.147,0,0,1,2.537-.105.823.823,0,0,1,.3,0l12-4.97a.245.245,0,0,1,0-.122,15.284,15.284,0,0,0,.368-1.75c-.228-.735-.35-1.522-.49-2.2a15.311,15.311,0,0,1-.385-3.36l-28.524,11.847-.28.28c-.84.77-5.81,3.815-6.7,2.625l-6.842,2.835a33.726,33.726,0,0,1-3.692-5.81,31.376,31.376,0,0,1-2.362-6.387l20.02-8.312c.473-.945.8-2.047,1.75-2.38a1.645,1.645,0,0,1,.332,1.5l29.749-12.372a33.861,33.861,0,0,1,3.692,5.827,32.71,32.71,0,0,1,2.362,6.37l-6.4,2.66c-.14,2.082-.193,4.182-.455,6.23v.63a.245.245,0,0,0,0,.105s.158.262.1.192l.3.315a.978.978,0,0,1,0,.14l7.367-3.062a26.547,26.547,0,0,1-12.442,23.415Z",
    transform: "translate(-57.33 17.937)",
    fill: "#3c486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M204.323,379.131c9.87-5.7,17.5,18.235.63,32.269s-40.249,2.642-27.824-25.217,37.5-28.874,46.059-20.474,6.51,28.892.35,27.859,5.407-20.475,14-19.127,6.755,21,1.75,18.865,4.742-13.51,11.5-13.16,5,13.562,1.277,13.16,2.975-10.815,17.5-10.15",
    transform: "translate(-33.936 25.197)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M256.051,173.882H216.345a1.575,1.575,0,0,1-1.557-1.33,6.72,6.72,0,0,0-6.457-5.565,4.917,4.917,0,0,0-5.022,5.25,1.523,1.523,0,0,1-.438,1.137,1.575,1.575,0,0,1-1.137.49H162.026a1.592,1.592,0,0,1-1.575-1.417l-1.977-19.7a1.54,1.54,0,0,1,.4-1.207,1.557,1.557,0,0,1,1.172-.525h94.025a1.557,1.557,0,0,1,1.557,1.417l1.995,19.67a1.557,1.557,0,0,1-1.575,1.75Zm-38.5-3.15H254.3l-1.662-16.52H161.781l1.662,16.52h36.749a8.015,8.015,0,0,1,2.152-4.427,8.155,8.155,0,0,1,5.932-2.467,9.975,9.975,0,0,1,9.31,6.895Z",
    transform: "translate(-45.31 -132.354)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(113.155 18.656)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M256.051,173.882H216.345a1.575,1.575,0,0,1-1.557-1.33,6.72,6.72,0,0,0-6.457-5.565,4.917,4.917,0,0,0-5.022,5.25,1.523,1.523,0,0,1-.438,1.137,1.575,1.575,0,0,1-1.137.49H162.026a1.592,1.592,0,0,1-1.575-1.417l-1.977-19.7a1.54,1.54,0,0,1,.4-1.207,1.557,1.557,0,0,1,1.172-.525h94.025a1.557,1.557,0,0,1,1.557,1.417l1.995,19.67a1.557,1.557,0,0,1-1.575,1.75Zm-38.5-3.15H254.3l-1.662-16.52H161.781l1.662,16.52h36.749a8.015,8.015,0,0,1,2.152-4.427,8.155,8.155,0,0,1,5.932-2.467,9.975,9.975,0,0,1,9.31,6.895Z",
    transform: "translate(-158.465 -151.01)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M164.142,152.915a2.572,2.572,0,0,0-1.243-2.135h82.02a2.572,2.572,0,0,1,1.242,2.135c.157,1.75-.822,2.152-.822,2.152H163.32S164.3,154.665,164.142,152.915Z",
    transform: "translate(-41.984 -132.527)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M164.142,152.915a2.572,2.572,0,0,0-1.243-2.135h82.02a2.572,2.572,0,0,1,1.242,2.135c.157,1.75-.822,2.152-.822,2.152H163.32S164.3,154.665,164.142,152.915Z",
    transform: "translate(-41.984 -132.527)",
    fill: "#fff",
    opacity: 0.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-3",
    transform: "translate(341.571 538.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M261.494,345.4l-42.8,31.254,42.8,31.237V397.566H369.606V355.725H261.494Z",
    transform: "translate(-218.69 -345.4)",
    fill: "#3c486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M249.3,369.958l.752-1.75a6.474,6.474,0,0,0,3.885,1.295c1.837,0,2.607-.647,2.607-1.522,0-2.537-7-.875-7-5.25,0-1.89,1.522-3.5,4.742-3.5a7.315,7.315,0,0,1,3.92,1.05l-.683,1.75a6.492,6.492,0,0,0-3.237-.927c-1.75,0-2.572.7-2.572,1.592,0,2.52,7,.875,7,5.25,0,1.89-1.523,3.5-4.76,3.5a7.577,7.577,0,0,1-4.655-1.487Z",
    transform: "translate(-195.734 -335.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M255.64,359.912a1.26,1.26,0,0,1,1.33-1.26,1.242,1.242,0,0,1,1.348,1.207,1.295,1.295,0,0,1-1.347,1.313,1.277,1.277,0,0,1-1.33-1.26Zm.28,2.73h2.1v8.995h-2.1Z",
    transform: "translate(-190.979 -335.465)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M267.735,361v7.63c0,3.255-1.75,4.742-4.847,4.742a7.175,7.175,0,0,1-4.375-1.277l.945-1.575a5.477,5.477,0,0,0,3.325,1.067c1.977,0,2.852-.91,2.852-2.73v-.473a3.9,3.9,0,0,1-3.01,1.207,4.375,4.375,0,0,1,0-8.75,3.92,3.92,0,0,1,3.115,1.295V360.93Zm-2.065,4.235a2.73,2.73,0,1,0-2.73,2.73A2.73,2.73,0,0,0,265.67,365.235Z",
    transform: "translate(-189.022 -333.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M274.1,364.823v5.145h-2.117v-4.882c0-1.592-.788-2.38-2.135-2.38a2.4,2.4,0,0,0-2.5,2.712v4.55h-2.1v-8.995h1.995v1.173a3.938,3.938,0,0,1,3.1-1.26,3.5,3.5,0,0,1,3.762,3.937Z",
    transform: "translate(-183.772 -333.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M283.327,366.28v5.145h-2.1v-4.882c0-1.592-.788-2.38-2.135-2.38a2.4,2.4,0,0,0-2.5,2.712v4.55h-2.1V358.93h2.1v4.55a4.007,4.007,0,0,1,2.992-1.137,3.5,3.5,0,0,1,3.745,3.937Z",
    transform: "translate(-176.842 -335.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M289.83,366.132h-7a2.73,2.73,0,0,0,2.9,2.17,3.29,3.29,0,0,0,2.45-.98l1.12,1.3a5.057,5.057,0,0,1-8.575-3.15,4.462,4.462,0,0,1,4.637-4.585,4.375,4.375,0,0,1,4.55,4.637A2.581,2.581,0,0,1,289.83,366.132Zm-7-1.382h5.092a2.432,2.432,0,0,0-2.537-2.187,2.485,2.485,0,0,0-2.625,2.187Z",
    transform: "translate(-172.163 -333.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M292.3,360.887v1.96h-.49a2.45,2.45,0,0,0-2.607,2.782v4.357h-2.1v-8.995h1.995V362.3a3.588,3.588,0,0,1,3.2-1.417Z",
    transform: "translate(-167.385 -333.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M299.751,366.132h-7a2.73,2.73,0,0,0,2.9,2.17,3.29,3.29,0,0,0,2.45-.98l1.12,1.295a5.057,5.057,0,0,1-8.575-3.15,4.462,4.462,0,0,1,4.637-4.585,4.375,4.375,0,0,1,4.55,4.637A3.433,3.433,0,0,0,299.751,366.132Zm-7-1.382h5.092a2.432,2.432,0,0,0-2.537-2.188,2.485,2.485,0,0,0-2.625,2.188Z",
    transform: "translate(-164.724 -333.792)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3",
    transform: "translate(506.44 230.947)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M416.15,228.092a234.509,234.509,0,0,1-19.915,14.787c-3.5,2.327-7,4.55-10.832,6.632-1.89,1.032-3.85,2.047-6,2.992-1.085.455-2.187.91-3.5,1.33-.595.21-1.295.42-1.977.595-.21,0-.262.088-.6.158l-.875.175a10.956,10.956,0,0,1-1.663.175,18.6,18.6,0,0,1-9.275-2.345,42.346,42.346,0,0,1-6.09-3.885,84.675,84.675,0,0,1-9.642-8.75A147.764,147.764,0,0,1,330.14,220.55l6.282-5.25c5.74,5.372,11.725,10.71,17.71,15.54a91.673,91.673,0,0,0,9.1,6.51,28.434,28.434,0,0,0,4.34,2.222,4.532,4.532,0,0,0,2.327.525h-.158a8.114,8.114,0,0,0,.893-.367,23.136,23.136,0,0,0,2.117-1.032c1.487-.805,3.062-1.75,4.637-2.73,3.15-1.995,6.317-4.217,9.485-6.475s6.3-4.655,9.432-7,6.282-4.847,9.327-7.175Z",
    transform: "translate(-299.977 -135.896)",
    fill: "#dc897c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M400.891,221.567c1.417,16.9-32.147,33.249-32.147,33.249l-11.165-18.2a193.4,193.4,0,0,1,20.894-22.049C389.307,205.362,399.946,210.332,400.891,221.567Z",
    transform: "translate(-279.398 -140.045)",
    fill: "#3c486b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M389.429,241.231a81.228,81.228,0,0,1-8.33,6.335,114.97,114.97,0,0,1-12.355,7.28l-11.165-18.2A192.485,192.485,0,0,1,378.492,214.6c10.815-9.24,21.472-4.27,22.4,7C401.486,228.6,396.009,235.544,389.429,241.231Z",
    transform: "translate(-279.398 -140.041)",
    fill: "#fff",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M341.807,221.107,332.48,208.49l-9.59,9.8s5.25,9.747,14.332,8.61Z",
    transform: "translate(-305.414 -141.004)",
    fill: "#e4897b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M324.937,205.73l-5.407,9.03,5.88,5.6,9.59-9.8Z",
    transform: "translate(-307.934 -143.074)",
    fill: "#e4897b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M379.35,230.5a81.232,81.232,0,0,1-8.33,6.335,53.638,53.638,0,0,1,5.775-12.757A11.182,11.182,0,0,1,379.35,230.5Z",
    transform: "translate(-269.318 -129.312)",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M378.513,409.42l13.177-.35a1.05,1.05,0,0,1,1.05.788l2.782,10.6a1.75,1.75,0,0,1-1.663,2.187c-4.76,0-11.637,0-17.6.123-7,.175-11.427-.158-19.617,0-4.952.14-6.51-4.812-4.462-5.25,9.362-2.31,15.487-1.855,23.467-7a5.372,5.372,0,0,1,2.87-1.1Z",
    transform: "translate(-284.108 9.422)",
    fill: "#263238"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(67.19 418.492)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M378.513,409.42l13.177-.35a1.05,1.05,0,0,1,1.05.788l2.782,10.6a1.75,1.75,0,0,1-1.663,2.187c-4.76,0-11.637,0-17.6.123-7,.175-11.427-.158-19.617,0-4.952.14-6.51-4.812-4.462-5.25,9.362-2.31,15.487-1.855,23.467-7a5.372,5.372,0,0,1,2.87-1.1Z",
    transform: "translate(-351.299 -409.07)",
    fill: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M416.824,409.42,430,409.07a1.05,1.05,0,0,1,1.05.788l2.765,10.6a1.75,1.75,0,0,1-1.663,2.187c-4.742,0-11.62,0-17.6.123-7,.175-11.427-.158-19.617,0-4.952.14-6.492-4.812-4.445-5.25,9.362-2.31,15.487-1.855,23.467-7a5.25,5.25,0,0,1,2.87-1.1Z",
    transform: "translate(-255.379 9.422)",
    fill: "#263238"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(134.228 418.492)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M416.824,409.42,430,409.07a1.05,1.05,0,0,1,1.05.788l2.765,10.6a1.75,1.75,0,0,1-1.663,2.187c-4.742,0-11.62,0-17.6.123-7,.175-11.427-.158-19.617,0-4.952.14-6.492-4.812-4.445-5.25,9.362-2.31,15.487-1.855,23.467-7a5.25,5.25,0,0,1,2.87-1.1Z",
    transform: "translate(-389.607 -409.07)",
    fill: "#fff"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M458.445,260.56c6.352,27.474-6.247,261.9-6.247,261.9l-20.807-.647-7.472-197.745L384.3,523.631,364.07,520.6c14.682-139.507,31.972-240.9,31.972-240.9V269.2Z",
    transform: "translate(-274.531 -101.953)",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M440.2,202.525a261.276,261.276,0,0,0,1,39.392c.857,9.135,2.082,17.78,3.377,25.584,3.01,18.287,6.457,31.989,7,36.749l-62.456,8.627c-22.749-63.7-14.192-97.49-14.192-97.49l14.3-8.172,3.167-.8a236.246,236.246,0,0,1,26.564-3.657c1.75-.158,3.413-.263,5.075-.333C432.5,202.052,440.2,202.525,440.2,202.525Z",
    transform: "translate(-267.572 -145.661)",
    fill: "#3c486b"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(105.672 56.606)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M451.532,304.273c-9.17,1.277-43.661,6.037-62.473,8.61-22.749-63.681-14.192-97.473-14.192-97.473l14.3-8.155s2.1-.56,3.185-.822a235.336,235.336,0,0,1,26.547-3.657c1.75-.14,3.412-.263,5.075-.332,8.54-.385,16.222,0,16.222,0a248.779,248.779,0,0,0,0,25.287c.245,4.812.6,9.52,1.015,14.1v.647c.875,8.89,2.065,17.325,3.325,24.937C447.629,285.794,451.059,299.5,451.532,304.273Z",
    transform: "translate(-373.289 -202.272)",
    fill: "#fff"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M409.269,214.667s-14.332,11.3-18.637,11.252c-3.027,0-7.4-4.97-7.4-4.97a12.984,12.984,0,0,0,4.725-3.78c2.992-4.112,1.26-9.082-1.19-13.65l12.582-17.5a83.546,83.546,0,0,0,1.61,12.67h0C402.375,205.532,404.93,212.234,409.269,214.667Z",
    transform: "translate(-260.161 -157.855)",
    fill: "#e4897b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M399.442,198.732h0c-1.312,7.63-4.637,16.432-13,18.427,2.992-4.112,1.26-9.082-1.19-13.65l12.582-17.5A83.545,83.545,0,0,0,399.442,198.732Z",
    transform: "translate(-258.647 -157.863)",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M387.46,214.815s3.5,3.167,7.472,6.23c4.795-3.185,15.925-11.532,14.577-17.832-.927-1.75-5.932-2.362-5.932-2.362S399.115,208.357,387.46,214.815Z",
    transform: "translate(-256.989 -146.733)",
    fill: "#3c486b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M391.3,213.21a33.932,33.932,0,0,0-5.74,7.822c-4.06-1.995-3.587-14.087-2.363-15.557a13.51,13.51,0,0,1,6.265-2.485,11.1,11.1,0,0,0,1.837,10.22Z",
    transform: "translate(-260.833 -145.128)",
    fill: "#3c486b"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(121.502 54.117)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M387.46,214.815s3.5,3.167,7.472,6.23c4.795-3.185,15.925-11.532,14.577-17.832-.927-1.75-5.932-2.362-5.932-2.362S399.115,208.357,387.46,214.815Z",
    transform: "translate(-378.491 -200.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M391.3,213.21a33.932,33.932,0,0,0-5.74,7.822c-4.06-1.995-3.587-14.087-2.363-15.557a13.51,13.51,0,0,1,6.265-2.485,11.1,11.1,0,0,0,1.837,10.22Z",
    transform: "translate(-382.335 -199.245)",
    fill: "#fff"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M394.657,343.849l7-38.324-1.347-20.264S390.719,320.417,394.657,343.849Z",
    transform: "translate(-252.303 -83.429)",
    opacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M374.4,179.93c-1.382,4.847-.28,14.7,6.352,11.3S376.785,171.582,374.4,179.93Z",
    transform: "translate(-267.173 -164.189)",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M408.911,188.833c1.085,12.355,2.345,19.529-2.9,26.669-7.91,10.762-23.9,7.28-28.664-4.532-4.287-10.622-5.337-29.032,5.95-35.577a17.08,17.08,0,0,1,25.619,13.44Z",
    transform: "translate(-266.838 -167.563)",
    fill: "#e4897b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M384.784,186.238c.14.98-.262,1.872-.91,1.96s-1.312-.647-1.47-1.645.262-1.872.927-1.96S384.627,185.31,384.784,186.238Z",
    transform: "translate(-260.806 -158.93)",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M378.314,187.138c.158,1-.262,1.872-.91,1.96s-1.312-.63-1.452-1.627.263-1.89.91-1.977S378.174,186.141,378.314,187.138Z",
    transform: "translate(-265.64 -158.256)",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M380.942,186.42a35,35,0,0,1-3.622,8.907,5.967,5.967,0,0,0,4.865.14Z",
    transform: "translate(-264.594 -157.555)",
    fill: "#de5753"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M387.731,184.369a.63.63,0,0,1-.595-.157,4.708,4.708,0,0,0-4.042-1.418.612.612,0,0,1-.717-.455.577.577,0,0,1,.455-.7,5.88,5.88,0,0,1,5.145,1.75.6.6,0,0,1,0,.84A.734.734,0,0,1,387.731,184.369Z",
    transform: "translate(-260.813 -161.192)",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M374.507,186.6a.595.595,0,0,1-.735-.752,5.828,5.828,0,0,1,3.727-3.885.6.6,0,0,1,.717.42.577.577,0,0,1-.4.735,4.5,4.5,0,0,0-2.9,3.1.63.63,0,0,1-.4.385Z",
    transform: "translate(-267.276 -160.915)",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M389.554,184.056s3.045-2.887,4.935-.49,2.765,9.362,2.765,9.362l.507-1.33s6.475,14.892,12.25,10.115,12.9-21.752-2.957-27.737c0,0-2.082-3.5-12.075-4.025s-21,7.122-22.084,13.842,2.187,9.9,2.187,9.9a9.276,9.276,0,0,1,1.347-4.06,4.06,4.06,0,0,0,2.835,2.625,7,7,0,0,1,.28-3.92,7.962,7.962,0,0,0,2.047,2.887c-.192-6.737,4.13-8.75,5.565-8.855a2.467,2.467,0,0,1,2.4,1.68Z",
    transform: "translate(-268.078 -169.925)",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M402.583,190.29a11.655,11.655,0,0,1-4.742,7.612c-3.377,2.362-6.475-.332-6.7-4.235-.21-3.5,1.295-8.995,5.25-9.8a5.355,5.355,0,0,1,6.195,6.422Z",
    transform: "translate(-254.245 -159.535)",
    fill: "#e4897b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M380.64,196.5a32.692,32.692,0,0,1,3.395,3.115l.665-.455c3.027-2.1,3.745-4.06,3.622-5.617a4.6,4.6,0,0,0-.752-2.1,4.428,4.428,0,0,0-.822-1,17.045,17.045,0,0,1-5.075,5.25A8.734,8.734,0,0,1,380.64,196.5Z",
    transform: "translate(-262.104 -154.533)",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M381.23,195.785l1.015.892c2.852-1.977,4.585-3.745,4.882-5.25a4.431,4.431,0,0,0-.823-1,17.044,17.044,0,0,1-5.075,5.355Z",
    transform: "translate(-261.661 -154.548)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M383,197.837c3.027-2.1,3.745-4.06,3.622-5.617a12.25,12.25,0,0,0-2.9,2.992,4.533,4.533,0,0,0-.717,2.625Z",
    transform: "translate(-260.335 -153.205)",
    fill: "#a24e3f"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M382.838,274.147l-1.207-6.615,63.663-9.362.98,11.567Z",
    transform: "translate(-261.361 -103.746)",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M386.775,264.1l.56,3.657-5.092.612-.612-3.64Z",
    transform: "translate(-261.361 -99.299)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M419.094,261.56l.577,3.867L386.44,269.4l-.56-3.692Z",
    transform: "translate(-258.174 -101.203)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M427.869,263.887l-21.1,2.52-.595-3.85L427.5,259.88Z",
    transform: "translate(-242.957 -102.463)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M392.324,264.856l.245,1.278a1.26,1.26,0,0,0,1.365,1l5.512-.665a1.243,1.243,0,0,0,1.085-1.435l-.157-1.312a1.243,1.243,0,0,0-1.382-1.085l-5.6.7a1.242,1.242,0,0,0-1.068,1.522Z",
    transform: "translate(-253.366 -100.405)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    y1: 0.21,
    x2: 1.732,
    transform: "translate(144.191 164.102)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M429.75,255.06,414,254.01l1.295,13.667s10.85,2.275,15.837-5.39Z",
    transform: "translate(-237.085 -106.866)",
    fill: "#e4897b"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M408.27,258.595l3.395,9.957,8.085-.875-1.277-13.667Z",
    transform: "translate(-241.383 -106.866)",
    fill: "#e4897b"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M414.46,232.545c-4.252-6.335-5.39-16.9-5.39-16.9a9.292,9.292,0,0,1,4.3,2.152c.245,4.812.6,9.52,1.015,14.1C414.407,232.107,414.425,232.335,414.46,232.545Z",
    transform: "translate(-240.783 -135.641)",
    opacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M420.312,204.9A254.785,254.785,0,0,1,437.9,223.957c2.817,3.325,5.547,6.755,8.137,10.5,1.295,1.837,2.59,3.727,3.815,5.792a38.094,38.094,0,0,1,3.5,7.35,18.04,18.04,0,0,1,.77,5.25,28,28,0,0,1-.315,4.165,54.352,54.352,0,0,1-1.61,7.1,106.124,106.124,0,0,1-4.69,12.582,178.5,178.5,0,0,1-12.25,22.924l-7.332-3.657c2.8-7.8,5.547-15.75,7.875-23.572a116.788,116.788,0,0,0,2.9-11.585,36.745,36.745,0,0,0,.7-5.337,17.5,17.5,0,0,0,0-2.17c0-.6-.193-1.015-.228-.945a27.875,27.875,0,0,0-2.327-3.885c-1.05-1.487-2.2-3.045-3.5-4.585-2.467-3.08-5.145-6.16-7.857-9.222s-5.565-6.055-8.4-9.082-5.74-6.02-8.522-8.96Z",
    transform: "translate(-241.158 -143.696)",
    fill: "#dc897c"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M413.819,202.463c16.765-2.59,35.454,29.749,35.454,29.749L431.9,244.62a190.752,190.752,0,0,1-23.449-19.25C398.454,215.15,402.672,204.2,413.819,202.463Z",
    transform: "translate(-245.479 -145.634)",
    fill: "#3c486b"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M413.819,202.463c16.765-2.59,35.454,29.749,35.454,29.749L431.9,244.62a190.752,190.752,0,0,1-23.449-19.25C398.454,215.15,402.672,204.2,413.819,202.463Z",
    transform: "translate(-245.479 -145.634)",
    fill: "#fff",
    opacity: 0.7
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    d: "M324.01,422.595l1.295,3.412,1.33-3.395.175-17.745-2.625-.017Z",
    transform: "translate(-304.574 6.258)",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M0,0H12.967V35.822a2.415,2.415,0,0,1-2.415,2.415H2.415A2.415,2.415,0,0,1,0,35.822Z",
    transform: "translate(30.814 55.545) rotate(-179.45)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M323.12,217.929l12.967.123.35-35.892a2.38,2.38,0,0,0-2.328-2.38h-8.277a2.328,2.328,0,0,0-2.362,2.31Z",
    transform: "translate(-305.241 -162.535)",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M326.512,196.58l17.657.175a6.09,6.09,0,0,1,6.02,5.932q4.357,167.891-3.5,335.834h0s-2.975,22.522-12.88,36.977h-4.357c-9.642-14.63-12.25-37.2-12.25-37.2h0q-4.392-167.943,3.167-335.9A6.09,6.09,0,0,1,326.512,196.58Z",
    transform: "translate(-310.89 -149.936)",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M316.187,193.9l29.749.28a1.75,1.75,0,0,1,1.75,1.837v2.992l-30.274-.3c-2.555,45.079-1.05,82.65-1.05,82.65l2.2,1.085-2.4,8.75c-5.337-15.032-2.66-82.825-2.1-95.32a2.047,2.047,0,0,1,2.117-1.977Z",
    transform: "translate(-312.903 -151.946)",
    fill: "#263238"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 36.014,
    height: 6.912,
    transform: "translate(40.806 215.767) rotate(-179.45)",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M352.954,327.372q-1.085,49.944-3.185,99.747a2.8,2.8,0,0,1-2.835,2.677l-28.209-.315a2.8,2.8,0,0,1-2.765-2.747q-1.19-49.716-1.26-99.747a2.817,2.817,0,0,1,2.835-2.817l32.654.315a2.817,2.817,0,0,1,2.765,2.887Z",
    transform: "translate(-311.556 -54.249)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 36.014,
    height: 6.912,
    transform: "translate(40.806 215.767) rotate(-179.45)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M316.187,193.9l29.749.28a1.75,1.75,0,0,1,1.75,1.837v2.992l-30.274-.3c-2.555,45.079-1.05,82.65-1.05,82.65l2.2,1.085-2.4,8.75c-5.337-15.032-2.66-82.825-2.1-95.32a2.047,2.047,0,0,1,2.117-1.977Z",
    transform: "translate(-312.903 -151.946)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M352.954,327.372q-1.085,49.944-3.185,99.747a2.8,2.8,0,0,1-2.835,2.677l-28.209-.315a2.8,2.8,0,0,1-2.765-2.747q-1.19-49.716-1.26-99.747a2.817,2.817,0,0,1,2.835-2.817l32.654.315a2.817,2.817,0,0,1,2.765,2.887Z",
    transform: "translate(-311.556 -54.249)",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 201,
    height: 40,
    transform: "translate(9066 1406)",
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Tawqia",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 9135.71, 1427.544)",
    fill: "#3c486b",
    fontSize: 16,
    fontFamily: "Georgia-Bold, Georgia",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Tawqia"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3C486B);
export default __webpack_public_path__ + "static/media/3c486b.83a99180d2b00f84007dc05be98ec2ca.svg";
export { ForwardRef as ReactComponent };